import { Injectable } from '@angular/core';
import { Store, Action } from '@ngrx/store';
import { Response } from '@angular/http';

import { Effect, Actions } from '@ngrx/effects';
import { Observable } from 'rxjs/Observable';
import { AppState } from '../../reducers';

import { VenueApi, OrderApi } from "../../services/webservice";
import { MessageActions } from '../../actions'
import { VenueActions } from './venue.actions'
import { ErrorHandlerService } from '../../services';
import { UnsafeAction } from '../../actions/UnsafeAction';

/* tslint:disable */
@Injectable()
export class VenueEffects {
	constructor(
		private updates$: Actions,
		private state$: Store<AppState> ,
 		private venueApi: VenueApi,
		private venueActions: VenueActions,
		private messageActions: MessageActions,
		private errorHandler: ErrorHandlerService
	) { }

	@Effect() loadVenueById$ = this.updates$
		.ofType(VenueActions.LOAD_VENUE_BY_ID)
		.flatMap((action: UnsafeAction) => this.venueApi.getVenueById(action.payload)
			.map(venue => this.venueActions.venueLoaded(venue))
			.catch(error => this.handleError(error, "Es ist ein unerwarteter Fehler aufgetreten."))
		)

	@Effect() searchVenues$ = this.updates$
		.ofType(VenueActions.SEARCH_VENUES)
		.flatMap((action: UnsafeAction) => this.venueApi.search(action.payload)
			.flatMap(searchResponse =>
				Observable.concat(
					[
						this.venueActions.searchVenuesSuccess(searchResponse._embedded.venues),
						this.venueActions.setPaginationConfig({
							itemsPerPage: searchResponse.page.size,
							totalItems: searchResponse.page.totalElements,
							currentPage: searchResponse.page.number
						})
					])
			)
		)

	private handleError(error: Response, defaultMessage:string): Observable<Action> {
		let errorMessage = this.errorHandler.getErrorMessage(error,	defaultMessage)
		return Observable.of(this.messageActions.displayMessage(errorMessage, "error"))
	}
}



// WEBPACK FOOTER //
// ./src/app/components/venue-components/venue.effects.ts